module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSemiBold.5b5be31.woff2";